import { Component, OnInit } from '@angular/core';
import { SelectItem, TreeNode } from 'primeng/api';
import { LookupService } from '../../services/lookups/lookup.service';
import { Router } from '@angular/router';
import { SearchDataService } from '../../services/searchData';

@Component({
  selector: 'app-home-search',
  templateUrl: './home-search.component.html',
  styleUrls: ['./home-search.component.css']
})
export class HomeSearchComponent implements OnInit {
  keyword: string;
  reportCategories: TreeNode[];
  countries: SelectItem[] = [];
  selectedCountries: Number[] = [];
  selectedNodes: TreeNode[] = [];

  constructor(
    private lookupService: LookupService,
    private router: Router,
    private searchDataService: SearchDataService,
  ) {}

  ngOnInit(): void {
    this.LoadReportCategoryHierarchy();
    this.LoadAllCountries();
  }

  search() {
    this.searchDataService.setSearchData(this.keyword, [], []);
    this.router.navigate(['/search']);
  }

  advSearch() {
    this.searchDataService.setSearchData("", this.selectedNodes, this.selectedCountries);
    this.router.navigate(['/search']);
  }

  private LoadReportCategoryHierarchy() {
    this.lookupService.getReportCategoryHierarchy$()
    .subscribe(data => {
      this.reportCategories = Array.of(data);
      this.reportCategories[0].expanded = true;
      this.reportCategories[0].children.sort((a, b) => {
        if (a.label < b.label) return -1;
        if (a.label > b.label) return 1;
        return 0;
      });
    });
  }

  private LoadAllCountries() {
    this.lookupService.getAllCountries$().subscribe(countryList => {
      this.countries.push({ label: 'All Countries', value: '' ,styleClass:'p-state-highlight'});
      countryList.forEach(val => {
        this.countries.push({ label: val.locationName.toString(), value: val.id });
      });
    });
  }

}
